import { createLogger } from '@yoti-web-share/logger'

export const logger = createLogger('share-flow', { prefix: 'Share-Flow' })
